var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"cg-stepper-progress",class:{'completed': _vm.state === 'completed'}},[(_vm.state === 'progress')?_c('div',{staticClass:"part-progress"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }